import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@material-ui/core";
import { Box } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CloseIcon from "@mui/icons-material/Close";

export default function ProductGalleryModal({
  open,
  onClose,
  productName,
  fotos,
  initialIndex = 0,
  brandColors,
}) {
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const photos = fotos || [];
  const hasMultipleFotos = photos.length > 1;

  useEffect(() => {
    if (open) {
      setCurrentIndex(initialIndex);
    }
  }, [open, initialIndex]);

  const handlePrev = () => {
    setCurrentIndex((i) => (i <= 0 ? photos.length - 1 : i - 1));
  };

  const handleNext = () => {
    setCurrentIndex((i) => (i >= photos.length - 1 ? 0 : i + 1));
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        style: {
          backgroundColor: brandColors.surface,
          borderRadius: "12px",
          overflow: "hidden",
        },
      }}
    >
      <DialogTitle
        style={{
          padding: "16px 24px",
          borderBottom: `1px solid ${brandColors.border}`,
        }}
      >
        <Box style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
          <span
            style={{
              fontSize: "18px",
              fontWeight: 600,
              color: brandColors.textBase,
            }}
          >
            {productName}
          </span>
          <IconButton
            onClick={onClose}
            size="small"
            style={{ color: brandColors.textMuted }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent
        style={{
          padding: 0,
          position: "relative",
          minHeight: "60vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#000",
        }}
      >
        {photos[currentIndex] && (
          <img
            src={photos[currentIndex]}
            alt={`${productName} - ${currentIndex + 1}`}
            style={{
              maxWidth: "100%",
              maxHeight: "70vh",
              objectFit: "contain",
            }}
            onError={(e) => {
              e.target.src =
                "https://placehold.co/600x600/ccc/fff?text=Error";
            }}
          />
        )}
        {hasMultipleFotos && (
          <>
            <IconButton
              onClick={handlePrev}
              style={{
                position: "absolute",
                left: "8px",
                top: "50%",
                transform: "translateY(-50%)",
                backgroundColor: brandColors.primary,
                color: "white",
                zIndex: 10,
              }}
              size="medium"
            >
              <ChevronLeftIcon />
            </IconButton>
            <IconButton
              onClick={handleNext}
              style={{
                position: "absolute",
                right: "8px",
                top: "50%",
                transform: "translateY(-50%)",
                backgroundColor: brandColors.primary,
                color: "white",
                zIndex: 10,
              }}
              size="medium"
            >
              <ChevronRightIcon />
            </IconButton>
          </>
        )}
        {hasMultipleFotos && (
          <div
            style={{
              position: "absolute",
              bottom: "16px",
              left: "50%",
              transform: "translateX(-50%)",
              display: "flex",
              gap: "8px",
              zIndex: 10,
            }}
          >
            {photos.map((_, idx) => (
              <div
                key={idx}
                style={{
                  width: "8px",
                  height: "8px",
                  borderRadius: "50%",
                  backgroundColor:
                    idx === currentIndex
                      ? brandColors.primary
                      : "rgba(255,255,255,0.5)",
                }}
              />
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
